'use client';

import { useRegionLocale } from 'contexts/RegionLocaleContext';
import { useEffect } from 'react';
import { useModal } from './Modal';
import { CustomImage as Image } from './custom-image';
import CustomLink from 'components/shared/CustomLink';
import { useTranslations } from 'next-intl';
import styles from './DiwaliPopup.module.css';

export const DiwaliPopupModal = ({ className }: { className?: string }) => {
  const ModalClient = useModal();
  const t = useTranslations('common');

  return (
    <div className={[styles.root, className].filter(Boolean).join(' ')}>
      <div className={styles.imageContainer}>
        <Image src="web_v2/gifting/gift-life-1.png" fill alt="" />
      </div>

      <div className={styles.textContainer}>
        <h2>{t('diwaliPopup.heading.happyDiwali')}</h2>
        <h3>{t('diwaliPopup.subheading.enjoy10Off')}</h3>
        <p className={styles.bold}>{t('diwaliPopup.text.whenYouBuy')}</p>

        <p>
          {t('diwaliPopup.text.everyRingOrder')}
          <ul>
            <li>{t('diwaliPopup.item.monthsExamineSubscription')}</li>
            <li>{t('diwaliPopup.item.blueLightBlocking')}</li>
            <li>{t('diwaliPopup.item.complimentaryUltrahumanxSubscription')}</li>
            <li>{t('diwaliPopup.item.ultrahumanApparelMore')}</li>
          </ul>
        </p>

        <CustomLink
          onClick={() => {
            ModalClient.hide();
            ModalClient.set(null);
          }}
          href="/ring/buy"
          className={styles.cta}
        >
          {t('diwaliPopup.link.shopNow')}
        </CustomLink>
      </div>
    </div>
  );
};

export const DiwaliPopup = () => {
  const { region: country } = useRegionLocale();
  const ModalClient = useModal();

  useEffect(() => {
    if (country !== 'IN' || !window) return;
    const dps = window.sessionStorage.getItem('diwaliPopupShown');
    if (dps === 'true') return;

    const timer = setTimeout(() => {
      ModalClient.set(<DiwaliPopupModal />);
      ModalClient.setCloseButtonTheme('light');
      ModalClient.show();
      window.sessionStorage.setItem('diwaliPopupShown', 'true');
    }, 10000);

    return () => clearTimeout(timer);
  }, [country]);
  return null;
};
